<template>
  <div id="create-new">
    <div v-if="!loading">
      <form
        method="post"
        @submit.prevent="upload($event)"
        action="/survey"
        enctype="multipart/form-data"
      >
        <div id="survey-name">
          <input
            class="survey-name-input"
            :placeholder="translations[language][PLACEHOLDER_SURVEY_NAME]"
            type="text"
            id="name"
            name="name"
            v-model="name"
            @keyup="validateName('#name')"
          />
        </div>

        <select id="language" name="lang" v-model="surveyLanguage" required>
          <option disabled selected value="">{{
            translations[language][LANGUAGE]
          }}</option>
          <option value="pt">{{ parseTranslation(LANGUAGE_PORTUGUESE) }}</option>
          <option value="es">{{ parseTranslation(LANGUAGE_SPANISH) }}</option>
          <option value="en">{{ parseTranslation(LANGUAGE_ENGLISH) }}</option>
        </select>

        <select id="type" name="type" v-model="type" required>
          <option disabled selected value="">{{ parseTranslation(TYPE) }}</option>
          <option value="CAWI">CAWI</option>
          <option value="CATI">CATI</option>
          <option value="CAPI">CAPI</option>
        </select>

        <div id="btn-create">
          <button type="submit" @click.prevent="createNew()">
            {{ parseTranslation(CREATE_NEW) }}
          </button>
        </div>
      </form>
    </div>

    <Loader v-else />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-2'

import * as translationCreate from './CreateNew.translations'

const { default: translations, ...translationKeys } = translationCreate

export default {
  name: 'createnew',

  components: {
    Loader,
  },

  data() {
    return {
      uploadText: 'Upload File',
      loading: false,
      name: '',
      surveyLanguage: '',
      type: '',
      translations,
      ...translationKeys,
    }
  },

  methods: {
    ...mapActions(['surveyRegister', 'sendMessage', 'executeSurveyAPICall']),

    validateName(element) {
      document.querySelector(element).value = document
        .querySelector(element)
        .value.replace(/\\/g, '')
    },

    async createNew() {
      if (this.loading) return

      if (!this.name || !this.surveyLanguage || !this.type) {
        return this.sendMessage(this.translations[this.language][this.REQUIRED_FIELDS])
      }

      this.loading = true

      const createdSurvey = await this.executeSurveyAPICall({
        path: '/survey',
        method: 'POST',
        payload: { lang: this.surveyLanguage, type: this.type, name: this.name },
      })

      if (!createdSurvey) return (this.loading = false)

      this.surveyRegister(createdSurvey)

      this.$router.push('/scheme')

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
#create-new {
  form {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 10px;
    @include d(s) {
      flex-direction: column;
    }
  }
}

#survey-name {
  flex: 1;
  max-width: 350px;
  margin-right: 30px;
  @include d(s) {
    width: 300px;
    margin-bottom: 20px;
    margin-right: 0;
  }
  input {
    width: 100%;
    color: $white;
  }
  ::placeholder {
    color: $white;
    opacity: 1;
  }

  ::-webkit-input-placeholder {
    color: $white;
  }

  :-moz-placeholder {
    color: $white;
  }

  ::-moz-placeholder {
    color: $white;
  }

  :-ms-input-placeholder {
    color: $white;
  }
  .light & {
    input {
      color: $gray-6;
    }
    ::placeholder {
      color: $gray-6;
      opacity: 1;
    }
    ::-webkit-input-placeholder {
      color: $gray-6;
    }

    :-moz-placeholder {
      color: $gray-6;
    }

    ::-moz-placeholder {
      color: $gray-6;
    }

    :-ms-input-placeholder {
      color: $gray-6;
    }
  }
}

.survey-name-input,
#language,
#type {
  @include tipography(16);
  color: $gray-5;
  background: none;
  border: 1px solid $gray-5;
  padding: 8px 10px;
  border-radius: 3px;

  &:focus {
    outline: none;
  }
}

#language,
#type {
  margin-right: 30px;
  color: $white;
  @include d(s) {
    margin-right: 0;
    width: 300px;
    margin-bottom: 20px;
  }
  option {
    color: $gray-6;
  }
  .light & {
    color: $gray-6;
  }
}

#btn-create {
  button {
    background: $blue;
    border: none;
    border-radius: 3px;
    padding: 10px 20px;
    @include tipography(15);
    letter-spacing: 3px;
    text-transform: uppercase;
    font-weight: bold;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
}

@media (max-width: 575.98px) {
  #btn-create {
    button {
      @include tipography(12);
    }
  }
}
</style>
